import { Configuration } from '@evimo/client';
import { OpenAPI } from '@evimo/client/openapi/core/OpenAPI';
import { API_URL } from '~/src/constants/env';

export function buildApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${normalizedPath}`;
}

export function createApiConfiguration(): Configuration {
  return new Configuration({
    basePath: API_URL,
    credentials: 'include',
  });
}

/**
 * Initialize the OpenAPI client configuration
 * This must be called before making any API requests
 */
export function initializeApiClient() {
  OpenAPI.BASE = API_URL;
  OpenAPI.WITH_CREDENTIALS = true;
  OpenAPI.CREDENTIALS = 'include';
}
